import * as angular from 'angular';
import { AppRootScope } from '../../typings/AppRootScope';

/**
 * Use expressions to determine if a form input is invalid
 * Adapted from Alex Schwartz' answer at https://stackoverflow.com/questions/12581439/how-to-add-custom-validation-to-an-angularjs-form
 */

export class InvalidIfDirective implements angular.IDirective {
    public static $name: string = 'invalidIf';
    public require: string = 'ngModel';

    public link =
        (scope: AppRootScope, element: angular.IAugmentedJQuery, attributes: angular.IAttributes, ngModel: angular.INgModelController) => {
            let argsObject = scope.$eval(attributes['invalidIf']);

            if (!angular.isObject(argsObject)) {
                argsObject = { invalidIf: attributes['invalidIf'] };
            }

            for (var validationKey in argsObject) {
                scope.$watch(argsObject[validationKey], (newVal) => {
                    ngModel.$setValidity(validationKey, !newVal);

                    if (ngModel.$invalid) {
                        ngModel.$setDirty();
                        ngModel.$setTouched();
                    }
                });
            }
        }

    public static Factory() {
        let directive = () => {
            return new InvalidIfDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
